import { Box, Typography } from "@material-ui/core";
import React from "react";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { TagFromTree } from "../../../models/TagsTree.model";
import { TagSelectionModal } from "./TagSelectionModal";

interface Props {
	open: boolean;
	handleClose: () => void;
	onTagSelect: (selected: TagFromTree) => void;
}

export const TagsTreeModal = ({ open, handleClose, onTagSelect }: Props) => {
	return (
		<>
			<MesfModal
				open={open}
				handleClose={handleClose}
				maxWidth={"lg"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Tags"
			>
				<MesfModal.Content>
					<Box>
						<Typography id="modal-modal-description">
							<TagSelectionModal
								isOpen={open}
								onClose={() => handleClose}
								onTagSelect={onTagSelect}
							/>
						</Typography>
					</Box>
				</MesfModal.Content>
			</MesfModal>
		</>
	);
};
